/**
 * Card slider (Kadence Row + Splide)
 * Usa la classe `.cardSlider` sul blocco row.
 */
export function initCardSlider() {
  const INIT_ATTR = "data-card-slider-splide-init";

  const buildMarkup = (container) => {
    if (!container) return null;

    if (!container.classList.contains("splide")) {
      container.classList.add("splide");
    }

    const columns = container.querySelectorAll(":scope > .wp-block-kadence-column");
    if (!columns.length) return null;

    container.classList.remove("kt-has-3-columns", "kt-mobile-layout-row", "kt-row-layout-equal");

    let track = container.querySelector(":scope > .splide__track");
    if (!track) {
      track = document.createElement("div");
      track.className = "splide__track";
      container.appendChild(track);
    }

    let list = track.querySelector(":scope > .splide__list");
    if (!list) {
      list = document.createElement("ul");
      list.className = "splide__list";
      track.appendChild(list);
    }

    columns.forEach((column) => {
      const slide = document.createElement("li");
      slide.className = "splide__slide";
      slide.appendChild(column);
      list.appendChild(slide);
    });

    if (!container.querySelector(":scope > .splide__arrows")) {
      const arrows = document.createElement("div");
      arrows.className = "splide__arrows";
      arrows.innerHTML =
        '<button class="splide__arrow splide__arrow--prev" type="button" aria-label="Precedente"></button>' +
        '<button class="splide__arrow splide__arrow--next" type="button" aria-label="Successivo"></button>';
      container.appendChild(arrows);
    }

    return container;
  };

  const initOne = (section) => {
    if (!section || !section.querySelector) return;
    const container = section.querySelector(".kt-row-column-wrap");
    if (!container) return;
    if (container.getAttribute(INIT_ATTR) === "1") return;
    if (!window.Splide) return;

    const root = buildMarkup(container);
    if (!root) return;

    container.setAttribute(INIT_ATTR, "1");

    const splide = new window.Splide(root, {
      type: "loop",
      perPage: 3,
      perMove: 1,
      rewind: true,
      pagination: false,
      arrows: true,
      drag: false,
      trimSpace: true,
      breakpoints: {
        767: { perPage: 1, gap: 0 },
      },
    });

    splide.mount();

    const syncTrackHeight = () => {
      const track = root.querySelector(":scope > .splide__track");
      const slides = root.querySelectorAll(":scope .splide__slide");
      if (!track || !slides.length) return;

      // Reset per ricalcolare correttamente al resize/font-load.
      track.style.height = "";

      let maxHeight = 0;
      slides.forEach((slide) => {
        const h = slide.offsetHeight || 0;
        if (h > maxHeight) maxHeight = h;
      });

      if (maxHeight > 0) {
        track.style.height = `${maxHeight}px`;
      }
    };

    const scheduleHeightSync = () => {
      window.requestAnimationFrame(syncTrackHeight);
      window.setTimeout(syncTrackHeight, 120);
    };

    splide.on("mounted moved resized updated refresh", scheduleHeightSync);
    scheduleHeightSync();
  };

  const initAll = () => {
    const nodes = document.querySelectorAll(".cardSlider");
    nodes.forEach((node) => initOne(node));
  };

  const observeMutations = () => {
    if (!window.MutationObserver) return;
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) continue;
        for (const node of mutation.addedNodes) {
          if (!node || node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains("cardSlider")) {
            initOne(node);
            continue;
          }
          if (node.querySelector && node.querySelector(".cardSlider")) {
            initAll();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  initAll();
  observeMutations();
}
